import axios from "axios";

const kmiStore = {
  state: {
    dataDeposit: [],
    totalDataDeposit: "",
    isLoading: false,
    dataTransaction: [],
    totalTransaction: "",
  },
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    setDataDeposit(state, payload) {
      state.dataDeposit = payload.body;
      state.totalDataDeposit = payload.count;
    },
    setDataTransaction(state, payload) {
      state.dataTransaction = payload.body;
      state.totalTransaction = payload.count;
    },
  },
  getters: {
    deposiDatas(state) {
      return state.dataDeposit;
    },
  },
  actions: {
    getTransaction({ commit }, { startDate, endDate, currentPage, perPage, clientType, bankCode }) {
      return new Promise((resolve, reject) => {
        let offset = (currentPage - 1) * perPage;
        commit("setLoading", true);
        axios
          .get("/v2/clearing/admin/abx/get/customer/transaction", {
            params: {
              startDate: startDate,
              endDate: endDate,
              offset: offset,
              limit: perPage,
              code: clientType,
              bank_code: bankCode,
            },
          })
          .then((res) => {
            commit("setDataTransaction", res.data.data);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDeposit({ commit }, { activity, perPage, currentPage, startDate, endDate, type }) {
      return new Promise((resolve, reject) => {
        let offset = (currentPage - 1) * perPage;
        commit("setLoading", true);
        axios
          .get("/v2/clearing/admin/abx/get/list/bullion", {
            params: {
              activity: activity,
              limit: perPage,
              type: type,
              startDate: startDate,
              endDate: endDate,
              offset: offset,
            },
          })
          .then((res) => {
            resolve(res.data.data);
            commit("setDataDeposit", res.data.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
  },
};

export default kmiStore;
